import { ReservationStatus } from '@localina/core';
import { ActionType, getType } from 'typesafe-actions';
import { ICancelReservationStore } from '../../interfaces/store/cancelReservation/ICancelReservationStore';
import * as actions from './cancelReservation-actions';

const initialState: ICancelReservationStore = {
    loading: false,
    error: undefined,
    reservation: undefined,
};

export default function cancelReservationReducer(
    state: ICancelReservationStore = initialState,
    action: ActionType<typeof actions>,
): ICancelReservationStore {
    switch (action.type) {
        case getType(actions.fetchReservation):
        case getType(actions.cancelReservation):
            return { ...state, error: undefined, loading: true };
        case getType(actions.reservationError):
            return {
                error: action.payload.error,
                loading: false,
                reservation: undefined,
            };
        case getType(actions.setReservation):
            return {
                error: undefined,
                loading: false,
                reservation: action.payload.reservation,
            };
        case getType(actions.cancelSuccess):
            return {
                loading: false,
                error: undefined,
                reservation: state.reservation
                    ? { ...state.reservation, status: ReservationStatus.GUEST_CANCELLED }
                    : state.reservation,
            };
        default:
            return state;
    }
}
